<script setup lang="ts">
// PROPS
interface Props {
    responsive?: boolean;
}

const { responsive = true } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const sellingMethod = useSlpSellingMethod();
const { appliedFilters, hasAppliedFilters, appliedFiltersCounter } = useSlpData();
const { reset } = useSlpParams(sellingMethod);
</script>

<template>
    <div v-if="hasAppliedFilters">
        <div class="flex-row flex-wrap items-center justify-start gap-3" :class="{ 'hidden lg:flex': responsive }">
            <SlpAppliedFilterBadges :applied-filters="appliedFilters" />
            <UButton variant="link" color="neutral" class="hidden p-0 text-base underline lg:block" @click="reset">
                {{ tt('slp.appliedFilters.reset') }}
            </UButton>
        </div>
        <BaseDeletableBadge v-if="!!appliedFiltersCounter && responsive" color="primary" variant="soft" size="lg" class="lg:hidden" @delete="reset">
            {{ tt('slp.appliedFilters.appliedFiltersCounter', { count: appliedFiltersCounter }) }}
        </BaseDeletableBadge>
    </div>
</template>
